"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminNotificationComponent = void 0;
const core_1 = require("@angular/core");
const system_notification_service_1 = require("./system-notification.service");
const system_notification_1 = require("./system-notification");
const user_service_1 = require("./user.service");
const organizations_service_1 = require("./organizations.service");
const notification_service_1 = require("./notification.service");
const users_service_1 = require("./users.service");
let AdminNotificationComponent = class AdminNotificationComponent {
    constructor(_systemNotification, _user, _organizations, _talk, _users) {
        this._systemNotification = _systemNotification;
        this._user = _user;
        this._organizations = _organizations;
        this._talk = _talk;
        this._users = _users;
        this.notificationsRoomName = 'systemnotification';
        this.notificationPositions = [
            'topLeft',
            'bottomLeft',
            'topCenter',
            'bottomCenter',
            'topRight',
            'bottomRight',
            'leftCenter',
            'rightCenter'
        ];
        this.notificationStates = ['pending', 'display'];
        this.notificationTypes = ['temporary', 'permanent'];
        this.targetTo = 'user';
        this.notifications = [];
        this.editingNotification = null;
    }
    ngOnInit() {
        this.resetNewnotification();
        this.organizations = this._organizations.get();
        this.currentUser = this._user.get();
        this.newNotification.org = this.currentUser.organization.id;
        this.users = this._users.get();
        this.loadNotifications();
    }
    loadNotifications() {
        this._systemNotification.getNotifications()
            .then(response => { this.notifications = response.json(); })
            .catch(err => console.error('Unable to get notifications', err));
    }
    createNotification($event, newNotification) {
        $event.preventDefault();
        let validation = this.validateNewNotification(newNotification);
        if (validation.isValid) {
            this._systemNotification.createNotification(validation.values, this.notificationsRoomName)
                .then(response => {
                if (response.json()) {
                    this.loadNotifications();
                    this.resetNewnotification();
                    this._talk.broadcast('<p>Notification Succesfully Created.</p>');
                }
            })
                .catch(err => {
                console.error('Unable to add notification', err);
                this._talk.broadcast('<p>Oops! We had an internal problem creating this notification.</p>');
            });
        }
        else {
            this._talk.broadcast(`<p> Please verify below errors to submit notification:</p>
        <ul>${validation.message}</ul>
      `);
        }
    }
    updateNotification(notificationIdx) {
        let notification = this.notifications[notificationIdx];
        this._systemNotification.createNotification(notification, this.notificationsRoomName)
            .then(response => {
            console.log('updated', response.json());
            notification.loading = false;
            notification.editing = false;
            this._talk.broadcast('Notification Updated');
        })
            .catch(err => {
            notification.loading = false;
            notification.editing = false;
            console.error('Unable to update notification', err);
            this._talk.broadcast('Unable to update notification');
        });
    }
    deleteNotification(notification) {
        this._talk.confirm(`<p>Are you sure you want to delete notification <b>${notification.id}</b>?</p>`)
            .then(resultPromise => {
            if (resultPromise.result)
                return resultPromise.result
                    .then(result => {
                    if (result) {
                        this._systemNotification.deleteNotification(notification.id, this.notificationsRoomName)
                            .then(res => {
                            if (res) {
                                this.loadNotifications();
                                this._talk.broadcast(`<p>Notification ${notification.id} Succesfully Deleted!</p>`);
                            }
                        })
                            .catch(err => {
                            this._talk.broadcast(`<p>Oops! we were Unable to delete Notification <b>${notification.id}</b></p>`);
                        });
                    }
                }); //Just adding catch to avoid UncaughtException error to be thrown
        }).catch(err => { });
    }
    resetNewnotification() {
        this.newNotification = new system_notification_1.SystemNotification({
            title: 'Biddr360 Notification',
            state: 'pending',
            position: 'bottomRight',
            type: 'permanent',
            startTime: null
        });
    }
    validateNewNotification(newNotification) {
        let validatedValues = {};
        let invalidMsg = '';
        if (this.targetTo === 'user') {
            let userId = this.verifyUserId(newNotification.user);
            if (!newNotification.user) {
                invalidMsg += '<li>A target user is required</li>';
            }
            else if (!userId) {
                invalidMsg += `<li>User (${newNotification.user}) it's not found on the system. Please enter a valid user.</li>`;
            }
            else {
                validatedValues.user = userId;
            }
        }
        if (this.targetTo === 'org') {
            if (!newNotification.org)
                invalidMsg += '<li>A target org is required</li>';
            else
                validatedValues.org = newNotification.org;
        }
        if (!newNotification.title)
            invalidMsg += '<li>A Title is required</li>';
        else
            validatedValues.title = newNotification.title;
        if (!newNotification.message)
            invalidMsg += '<li>A message is required</li>';
        else
            validatedValues.message = newNotification.message;
        // Disabled until new date picker
        //if (newNotification.type === 'temporary') {
        // if (!newNotification.startDate || !newNotification.startTime) invalidMsg += '<li>A Start Date and Start Time are required</li>';
        // else {
        //   validatedValues.startTime = this.parseTime(newNotification.startDate, newNotification.startTime);
        // };
        // if (newNotification.endDate && !newNotification.endTime || newNotification.endTime && !newNotification.endDate) {
        //   invalidMsg += '<li>A End Date and End Time must be set</li>';
        // } else if (newNotification.endDate && newNotification.endTime) { 
        //   validatedValues.endTime = this.parseTime(newNotification.endDate, newNotification.endTime);
        // }
        //}
        validatedValues.type = newNotification.type;
        validatedValues.state = newNotification.state;
        validatedValues.position = newNotification.position;
        return {
            message: invalidMsg,
            isValid: !invalidMsg,
            values: validatedValues
        };
    }
    verifyUserId(userIdOrEmail) {
        if (!userIdOrEmail)
            return null;
        let foundUserId;
        if (userIdOrEmail.includes('@')) { //Only check for @ since the string should exist on users if valid
            foundUserId = this._users.getUserByEmail(userIdOrEmail).id;
        }
        else if (!isNaN(parseInt(userIdOrEmail))) {
            foundUserId = this._users.getUserById(userIdOrEmail).id;
        }
        return foundUserId || null;
    }
    parseTime(date, time) {
        let times, dateTime = moment(date);
        if (time) {
            times = time.split(':'); //hour [0], minutes [1];
            dateTime.hour(times[0]);
            dateTime.minute(times[1]);
        }
        return dateTime.utc().format('YYYY-MM-DD HH:MM');
    }
    userIdDisplayName(userId) {
        if (userId) {
            return this._users.getUserById(userId).email;
        }
        return '';
    }
    organizationIdDisplayName(orgId) {
        if (orgId) {
            let org = this._organizations.getOrgById(orgId);
            return !!org ? org.displayName : '';
        }
        return '';
    }
};
exports.AdminNotificationComponent = AdminNotificationComponent;
exports.AdminNotificationComponent = AdminNotificationComponent = __decorate([
    (0, core_1.Component)({
        selector: 'admin-notifications',
        templateUrl: 'app/admin-notification.component.html'
    }),
    __metadata("design:paramtypes", [system_notification_service_1.SystemNotificationService,
        user_service_1.UserService,
        organizations_service_1.OrganizationsService,
        notification_service_1.NotificationService,
        users_service_1.UsersService])
], AdminNotificationComponent);
//# sourceMappingURL=admin-notification.component.js.map